export default [
    {
        path: '',
        name: 'team',
        redirect: {
            name: 'team.people',
        },
        component: () => import(/* webpackChunkName: "team-module" */ './Index.vue'),
        children: [
            {
                path: 'people',
                name: 'team.people',
                component: () => import(/* webpackChunkName: "team-module" */ './People.vue'),
                children: [
                    {
                        path: 'setup',
                        name: 'team.people.setup',
                        component: () =>
                            import(/* webpackChunkName: "team-module" */ './components/DefaultTasksForm/index'),
                    },
                    {
                        path: ':id',
                        name: 'team.person',
                        component: () => import(/* webpackChunkName: "team-module" */ './panels/WorkerPanel/index'),
                    },
                    {
                        path: 'new',
                        name: 'team.newperson',
                        component: () => import(/* webpackChunkName: "team-module" */ './panels/WorkerPanel/index'),
                    },
                ],
            },
            {
                path: 'roles',
                name: 'team.roles',
                component: () => import(/* webpackChunkName: "team-module" */ './TeamRoles/index'),
                children: [
                    {
                        path: 'setup',
                        name: 'team.roles.setup',
                        component: () =>
                            import(/* webpackChunkName: "team-module" */ './components/DefaultTasksForm/index'),
                    },
                    {
                        path: ':id',
                        name: 'team.role',
                        component: () => import(/* webpackChunkName: "team-module" */ './panels/RolePanel/index'),
                    },
                    {
                        path: 'new',
                        name: 'team.newrole',
                        component: () => import(/* webpackChunkName: "team-module" */ './panels/RolePanel/index'),
                    },
                ],
            },
        ],
    },
];
